<template>
  <div>
    <Head title="AreaProjects" />
    <h1 class="mb-8 text-3xl font-bold">
      Master
      <span class="text-indigo-400 font-medium"> / </span>
      AreaProjects
    </h1>
    <div class="flex items-center justify-between mb-6 md:w-1/2">
      <search-filter
        v-model="form.search"
        :show-dropdown="false"
        class="mr-4 w-full max-w-md"
        @reset="reset" />
      <Link class="btn-indigo" href="/areaprojects/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;AreaProject</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto md:w-1/2">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">
              Code
            </th>
            <th class="pb-4 pt-6 px-6">
              Location
            </th>
            <th class="pb-4 pt-6 px-6" colspan="2">
              Description
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="areaproject in areaprojects.data"
            :key="areaproject.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/areaprojects/${areaproject.id}/edit`">
                {{ areaproject.code }}
                <icon
                  v-if="areaproject.deleted_at"
                  name="trash"
                  class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/areaprojects/${areaproject.id}/edit`"
                tabindex="-1">
                {{ areaproject.location }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/areaprojects/${areaproject.id}/edit`"
                tabindex="-1">
                {{ areaproject.desc }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link
                class="flex items-center px-4"
                :href="`/areaprojects/${areaproject.id}/edit`"
                tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="areaprojects.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">
              No areaprojects found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="areaprojects.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
        SearchFilter,
    },
    layout: Layout,
    props: {
        filters: Object,
        areaprojects: Object,
    },
    data () {
        return {
            form: {
                search: this.filters.search,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/areaprojects', pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        reset () {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
